import { styled, TextField } from '@material-ui/core';
import themes from 'styles/themes';

const styles = {
    input: {
        borderBottom: `1px solid ${themes.palette.grey['500']} !important`,
        color: themes.palette.primary.main,
        opacity: 1,
    },
    inputAutofill: {
        borderBottom: `1px solid ${themes.palette.grey['500']} !important`,
        color: themes.palette.primary.main,
        opacity: 1,
        '-webkit-box-shadow': '0 0 0 30px white inset !important',
        '-webkit-text-fill-color': `${themes.palette.primary.main} !important`,
        '&:focus': {
            '-webkit-box-shadow': '0 0 0 30px white inset !important',
            '-webkit-text-fill-color': `${themes.palette.primary.main} !important`,
        },
        '&:hover': {
            '-webkit-box-shadow': '0 0 0 30px white inset !important',
            '-webkit-text-fill-color': `${themes.palette.primary.main} !important`,
        },
        '&:active': {
            '-webkit-box-shadow': '0 0 0 30px white inset !important',
            '-webkit-text-fill-color': `${themes.palette.primary.main} !important`,
        },
    },
    inputPlaceholder: {
        color: `${themes.palette.primary.main} !important`,
        opacity: 0.5,
    },
};

export const StandardTextField = styled(TextField)({
    '& input': styles.input,
    '& input:-webkit-autofill': styles.inputAutofill,
    '& input::placeholder': styles.inputPlaceholder,
    '& [class*="MuiInputBase-root"]': {
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '24px',
        color: themes.palette.primary.main,
    },
    '& [class*="MuiFormHelperText-root"]': {
        color: 'red !important',
        fontFamily: 'PoppinsRegular',
        padding: 0,
        margin: '4px 0 0 0',
        fontSize: 12,
    },
    '& [class*="MuiInputBase-root"].Mui-focused': {
        borderBottom: 0,
    },
    '& [class*="MuiInput-underline"].Mui-focused': {
        bottom: 0,
    },
    '& [class*="MuiInput-underline"]:not(.Mui-disabled):before': {
        borderBottom: 0,
    },
    '& [class*="MuiInput-underline"]:not(.Mui-disabled):after': {
        borderBottom: 0,
    },
    '& [class*="MuiInputBase-input"]:not(.Mui-focused)': {
        padding: '6px 0 10px',
    },
    '& label[class*="MuiInputLabel-root"]': {
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '24px',
        color: themes.palette.primary.main,
        opacity: 0.5,
        top: '0!important',
    },
});
